import React, { useRef } from 'react';
import { Box, Button, Divider, Grid2 as Grid, LinearProgress, MenuItem, Paper, TextField } from '@mui/material';
import { stateOptions } from '../../../Utils';


const RestitutionModal = (props) => {
    const { ts, state, handleFieldChange, handleCreateRestitution, handleCloseRestitutionModal, loading, handleTotalRestitutionFocus, handleMonthlyPaymentFocus } = props;
    const totalRestitutionRef = useRef(null);
    const monthlyPaymentRef = useRef(null);
    const isSaveDisabled = /^\s*$/.test(state.startDate) || parseFloat(state.totalRestitutionAmount.replace(/[^0-9.-]+/g, "")) < 0.01 || /^\s*$/.test(state.remitterName) || /^\s*$/.test(state.remitterAddress1) || /^\s*$/.test(state.remitterCity) ||
        /^\s*$/.test(state.remitterState) || /^\s*$/.test(state.remitterZipCode)

    return (

        <Paper elevation={10}>
            <Paper className="border-radius-bottom" sx={{ textAlign: 'center', backgroundColor: 'steelblue', color: 'white', p: '1vh' }} elevation={10}>
                <h1>Create Restitution</h1>
            </Paper>
            <Box sx={{ width: "98%", m: "auto", pb: "1vh", pt: "2vh" }}>
                <Paper
                    sx={{
                        height: "auto",
                        padding: 'auto',
                        border: '1px grey white',
                        borderStyle: 'inset'
                    }}
                    elevation={10}
                >
                    <Box sx={{
                        diaplay: 'flex',
                        justifyContent: 'flex-start',
                        marginLeft: '.5vw',
                        mt: '.3vh',
                        padding: 0,
                        paddingLeft: 2,
                        paddingRight: 2,

                    }}
                    >
                        <h2>Restitution Information</h2>
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={1.5}
                            columns={12}
                            sx={{
                                display: 'flex',
                                flex: 1,
                                width: 'auto',
                                boxSizing: 'border-box',
                                margin: 0,
                                padding: 0,
                                paddingLeft: 2,
                                paddingRight: 2,
                                mt: '0vh',
                                justifyContent: 'flex-start',

                            }}
                        >
                            <Grid item size={8}>
                                <TextField
                                    id="restitutionType"
                                    label="Restitution Type"
                                    name="restitutionType"
                                    value={state.restitutionType}
                                    variant="outlined"
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) => { handleFieldChange('restitutionType', e.target.value.replace(/[^A-Za-z ]/g, '')) }}
                                    placeholder="ex: Direct Restitution, Restitution Order, Mandatory Restitution..."
                                />
                            </Grid>
                            <Grid item size={4}>
                                <TextField
                                    required
                                    inputRef={totalRestitutionRef}
                                    id="totalRestitutionAmount"
                                    label="Total Restitution Amount"
                                    name="totalRestitutionAmount"
                                    value={state.totalRestitutionAmount}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    placeholder="ex: $2,400"
                                    onChange={(e) => handleFieldChange('totalRestitutionAmount', e.target.value.replace(/[^0-9.]/g, ''))}
                                    onFocus={handleTotalRestitutionFocus}
                                    onBlur={(e) => { handleFieldChange('totalRestitutionAmount', new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(e.target.value.replace(/[^0-9.]/g, ''))) }}
                                />
                            </Grid>
                            <Grid item size={6}>
                                <TextField
                                    required
                                    id="startDate"
                                    label="Restitution Start Date"
                                    name="startDate"
                                    value={state.restitutionStartDate}
                                    type="date"
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) => handleFieldChange('startDate', e.target.value)}
                                />
                            </Grid>
                            <Grid item size={6}>
                                <TextField
                                    id="endDate"
                                    label="Restitution End Date"
                                    name="endDate"
                                    value={state.endDate}
                                    type="date"
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) => handleFieldChange('endDate', e.target.value)}
                                />
                            </Grid>
                            {/*<Grid item size={4}>*/}
                            {/*    <TextField*/}
                            {/*        required*/}
                            {/*        inputRef={monthlyPaymentRef}*/}
                            {/*        id="monthlyPaymentAmount"*/}
                            {/*        label="Monthly Payment Amount"*/}
                            {/*        name="monthlyPaymentAmount"*/}
                            {/*        value={state.monthlyPaymentAmount}*/}
                            {/*        sx={{ ...ts, width: '100%' }}*/}
                            {/*        slotProps={{ inputLabel: { shrink: true } }}*/}
                            {/*        placeholder="ex: $100.00"*/}
                            {/*        onChange={(e) => handleFieldChange('monthlyPaymentAmount', e.target.value.replace(/[^0-9.]/g, ''))}*/}
                            {/*        onFocus={handleMonthlyPaymentFocus}*/}
                            {/*        onBlur={(e) => { handleFieldChange('monthlyPaymentAmount', new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(e.target.value.replace(/[^0-9.]/g, ''))) }}*/}
                            {/*    />*/}
                            {/*</Grid>*/}
                            {/*<Grid item size={4}>*/}
                            {/*    <TextField*/}
                            {/*        required*/}
                            {/*        id="duration"*/}
                            {/*        label="Duration (months)"*/}
                            {/*        name="duration"*/}
                            {/*        value={state.duration}*/}
                            {/*        sx={{ ...ts, width: '100%' }}*/}
                            {/*        slotProps={{ inputLabel: { shrink: true } }}*/}
                            {/*        onChange={(e) => handleFieldChange('duration', e.target.value.replace(/[^0-9]/g, ''))}*/}
                            {/*        placeholder="ex: 24"*/}
                            {/*    />*/}
                            {/*</Grid>*/}
                        </Grid>
                    </Box>
                    <Divider variant="middle" flexItem sx={{ mt: '1vh', fontWeight: '700', backgroundColor: 'grey', height: '2.5px' }} />
                    <Box sx={{
                        diaplay: 'flex',
                        justifyContent: 'flex-start',
                        marginLeft: '.5vw',
                        mt: '.3vh',
                        padding: 0,
                        paddingLeft: 2,
                        paddingRight: 2,
                    }}
                    >
                        <h2>Remitter Information</h2>
                    </Box>
                    <Box sx={{ display: 'flex' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={1.5}
                            columns={12}
                            sx={{
                                display: 'flex',
                                flex: 1,
                                width: 'auto',
                                boxSizing: 'border-box',
                                margin: 0,
                                padding: 0,
                                paddingLeft: 2,
                                paddingRight: 2,
                                mt: '0vh',
                                justifyContent: 'flex-start',
                                marginBottom: '1vh',
                            }}
                        >
                            <Grid item size={12}>
                                <TextField
                                    required
                                    id="remitterName"
                                    label="Remitter Name"
                                    name="remitterName"
                                    value={state.remitterName}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    onChange={(e) => handleFieldChange('remitterName', e.target.value)}
                                    placeholder="ex: Jane Smith"
                                />
                            </Grid>
                            <Grid item size={6}>
                                <TextField
                                    required
                                    id="remitterAddress1"
                                    label="Remitter Address 1"
                                    name="remitterAddress1"
                                    value={state.remitterAddress1}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    placeholder="ex: 123 Main St."
                                    onChange={(e) => handleFieldChange('remitterAddress1', e.target.value)}
                                />
                            </Grid >
                            <Grid item size={4}>
                                <TextField
                                    id="remitterAddress2"
                                    label="Remitter Address 2"
                                    name="remitterAddress2"
                                    value={state.remitterAddress2}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    placeholder="ex: Apt. 1234"
                                    onChange={(e) => handleFieldChange('remitterAddress2', e.target.value)}
                                />
                            </Grid >
                            <Grid item size={4}>
                                <TextField
                                    required
                                    id="remitterCity"
                                    label="Remitter City"
                                    name="remitterCity"
                                    value={state.remitterCity}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    placeholder="ex: Baton Rouge"
                                    onChange={(e) => { handleFieldChange('remitterCity', e.target.value) }}
                                />
                            </Grid>
                            <Grid item size={2}>
                                <TextField
                                    required
                                    select
                                    id="remitterState"
                                    label="Remitter State"
                                    name="remitterState"
                                    value={state.remitterState}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                style: {
                                                    maxHeight: '20em',
                                                },
                                            },
                                        },
                                    }}
                                    placeholder="ex: LA"
                                    onChange={(e) => { handleFieldChange('remitterState', e.target.value) }}
                                >
                                    <MenuItem value=''>N/A</MenuItem>
                                    {
                                        stateOptions?.map(({ value, label }) => {
                                            return <MenuItem key={label} value={value}>{label}</MenuItem>
                                        })
                                    }
                                </TextField>
                            </Grid>
                            <Grid item size={2}>
                                <TextField
                                    id="remitterZipCode"
                                    label="Remitter Zip Code"
                                    name="remitterZipCode"
                                    value={state.remitterZipCode}
                                    sx={{ ...ts, width: '100%' }}
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    placeholder={"ex: 55555"}
                                    onChange={(e) => { handleFieldChange('remitterZipCode', e.target.value.replace(/[^0-9]/g, '')) }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
                <Box sx={{ display: "flex", justifyContent: "right", gap: '.5rem', mt: '1vh' }}>
                    <Button variant="contained" sx={{ backgroundColor: "steelblue", color: "white" }} onClick={async () => await handleCreateRestitution()} disabled={loading || isSaveDisabled}>Save</Button>
                    <Button variant="contained" sx={{ backgroundColor: "steelblue", color: "white" }} onClick={handleCloseRestitutionModal} disabled={loading}>Close</Button>
                </Box>

            </Box>
            {
                loading && <LinearProgress />
            }
        </Paper>
    )

}

export default RestitutionModal;